module.exports = __webpack_public_path__ + "static/media/Single Matting Vertical Text and Logo.991ca41d.png";